import { TextField } from "@mui/material";
import styled from "styled-components";
import materialUI from "../../../../material-UI";
import color from "../../../../constants/color";

export const Content = styled.div`
  width: 392px;
  min-height: 337px;
  padding: 24px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonClear = styled.button`
  background-color: transparent;
  color: #2d5bff;
  border: none;
  cursor: pointer;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
`;

export const ButtonFilter = styled.button`
  background-color: transparent;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  border-radius: 8px;
  border: none;
  cursor: pointer;
  height: 40px;
  width: 100%;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  color: #ffffff;
  :disabled {
    opacity: 50%;
    cursor: not-allowed;
  }
`;

export const TextFilter = styled.p`
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 24.2px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const LabelText = styled.span`
  display: block;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;
`;

export const Autocomplete = styled(materialUI.Autocomplete)`
  .MuiOutlinedInput-root {
    fieldset {
      border-radius: 8px;
    }
  }

  .MuiInputBase-input {
    padding: 0 !important;
  }

  .Mui-focused {
    fieldset {
      border-color: ${color.primary} !important;
    }
  }
  .Mui-disabled {
    background-color: rgb(242, 244, 248);
  }
`;

export { TextField };
